import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
import r from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, e, p, f, i, m) {
  return t(), o("svg", a, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M18.449 4.25a3.306 3.306 0 0 1 3.3 3.328l-.002-.067.003.041V17a3.75 3.75 0 0 1-3.55 3.745l-.2.005H6a3.75 3.75 0 0 1-3.745-3.55L2.25 17V7.551c0-.058.007-.114.019-.168l.003-.048A3.301 3.301 0 0 1 5.566 4.25ZM3.75 10.307V17a2.25 2.25 0 0 0 2.096 2.245L6 19.25h12a2.25 2.25 0 0 0 2.245-2.096L20.25 17v-6.683l-4.455 3.022a6.75 6.75 0 0 1-7.344.15l-.23-.15-4.471-3.032ZM18.449 5.75H5.566c-.95 0-1.736.739-1.796 1.658l-.005.143a1.8 1.8 0 0 0 .79 1.491l4.507 3.055a5.25 5.25 0 0 0 5.891 0l4.507-3.055c.457-.31.747-.812.784-1.336l.006-.154c0-.996-.806-1.802-1.801-1.802Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", c]]);
export {
  u as default
};
